import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f77f276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-label mt-2 tooltip-alternative-mobile" }
const _hoisted_2 = { class: "relative inline-block" }
const _hoisted_3 = { class: "tooltip" }

import { ref } from 'vue';


export default {
  __name: 'TooltipButton',
  setup(__props) {

const isVisible = ref(false);

const toggleVisible = () => {
    isVisible.value = !isVisible.value;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "tooltip")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: toggleVisible,
        class: "Button--no-style tooltip-button",
        type: "button"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "tooltip")
          ], 512), [
            [_vShow, isVisible.value]
          ])
        ]),
        _: 3
      })
    ])
  ], 64))
}
}

}